import GatewayAxiosClient from '../GatewayAxiosClient';
import { getToken } from '../../session';
import type { EventSearchParams, ManifestEventResponse } from './types';
import qs from 'qs';

export class ScheduleService {
  public async searchAllManifestScheduleEvents(params: EventSearchParams): Promise<ManifestEventResponse[]> {
    const res = await GatewayAxiosClient(`/manifests/schedules/events`, {
      method: 'GET',
      params: params,
      headers: {
        authorization: `Bearer ${getToken()}`,
      },
      paramsSerializer: (p) => {
        return qs.stringify(p, { arrayFormat: 'comma' });
      },
    });
    return res.data;
  }
}
